import { dismissWarningAll } from './warning_message';

export const fiQuotaService = {
  dismissWarningAll,
};
